import http from "../http-common";

class BitacoraService {

    create(data) {
        return http.post("/bitacora",data);
    }

    getAll() {
        return http.get("/bitacora");
    }

    updateBitacora(id, data) {
        return http.put(`/bitacora/${id}`,data);
    }

    eliminarBitacora(id) {
        return http.delete(`/bitacora/${id}`);
    }
}

export default new BitacoraService();